export const areUrlsEqual = (a: URL, b: URL): boolean => {
  try {
    const aCopy = new URL(a);
    const bCopy = new URL(b);

    aCopy.searchParams.sort();
    bCopy.searchParams.sort();

    return aCopy.toString() === bCopy.toString();
  } catch {
    return false;
  }
};
